export default __webpack_public_path__ + "static/media/bv-logo-black.d216c4ae.svg";